import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FolderIcon(props: IconProps) {
    return <Icon {...props} iconKey={"folder"}/>
}
